import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import RetailPage from 'src/containers/Page/RetailPage';
import './OMR.scss';
import Button from 'src/components/Button/Button';
import SimpleTabs from 'src/components/SimpleTabs/SimpleTabs';
import classNames from 'classnames';
import { RootState } from 'src/configs/store';
import ResponsePage from 'src/components/Retail/OMR/ResponsePage';
import usePreviousValue from 'src/hooks/usePreviousValue';
import BreadCrumb from 'src/components/Retail/BreadCrumb/BreadCrumb';

function OMR() {
  const [title, setTitle] = useState('');
  const [showResponse, setShowResponse] = useState(false);
  const [tab, setTab] = useState(0);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { omr:{ omrMockData, commands:{ mainTests, otherTests }, data } } = useSelector((state: RootState) => state.peripherals);
  const query = new URLSearchParams(location.search);
  const prevValue = usePreviousValue(query.get('card'));

  useEffect(() => {
    if (!_.isEmpty(data?.config) || !_.isEmpty(data.matrix?.matrix) || !_.isEmpty(data.status)){
      setShowResponse(true);
    }

    if (query.has('tab')){
      setTab(+query.get('tab'));
    }

    if (query.has('title')){
      setTitle(query.get('title'));
    }

    dispatch.peripherals.changeBetInfo(false);
  }, [data]);

  useEffect(() => {
    if (query.has('card') && prevValue !== query.get('card')) {
      dispatch.peripherals.getCardbyId(query.get('card'));
      setShowResponse(true);
    }
  }, [query]);

  const handleClick = (value, response) => async (e) => {
    e.preventDefault();
    setTitle(e.target.name);

    await dispatch.peripherals.getReaderResponse({ command: value });
    if (response){
      setShowResponse(true);
    }
  };

  const goBack = (e) => {
    e.preventDefault();
    setShowResponse(false);
  };

  const handleTabChange = (e, val: number) => {
    e.preventDefault();

    setTab(val);
    setShowResponse(false);
  };

  const checkBreadcrumbs = () => {
    if (query.get('tab') !== '-1'){
      return [
        { name: t('omr.home'), link: '/' },
        { name: t('omr.tests'), link: '/tests' },
        { name: t('omr.testOMR'), link: '/test-omr' },
        { name: tab === 0 ?  t('omr.mainTests')  :  t('omr.otherTests'), link: '/test-omr' },
        { name:  showResponse ? title : '', link: '' }
      ];
    } else {
      return [
        { name: t('omr.home'), link: '/' },
        { name: t('omr.tests'), link: '/tests' },
        { name:  showResponse ? title : '', link: '' }
      ];
    }
  };

  return (
    <RetailPage includeBetslip={ false }>
      <div className="omr">
        <BreadCrumb
          breadcrumbs={ checkBreadcrumbs() }
          auxFunction={ () => setShowResponse(false) }
        />
        <div className="omr__header">
          <div className="omr__toggle">
            <span className="omr__toggle-title"> Test </span>
            <div className="toggle-switch">
              <input
                type="checkbox"
                className="toggle-switch-checkbox"
                name="toggleSwitch"
                id="toggleSwitch"
                checked={ omrMockData }
                onChange={ () => dispatch.peripherals.changeOmrMockData(!omrMockData) }
              />
              <label className="toggle-switch-label" htmlFor="toggleSwitch">
                <span className="toggle-switch-inner" />
                <span className="toggle-switch-switch" />
              </label>
            </div>
          </div>
        </div>
        <SimpleTabs
          labels={
            [
              { label: 'Main Tests' },
              { label: 'Other Tests' }
            ]
          }
          containerClass="omr"
          showIndicator={ false }
          defaultTab={ tab }
          onChange = { handleTabChange }
        >
          {
            !showResponse && <div className="omr__page">
              {
                _.map(mainTests, (value, key) => {
                  return (
                    <div className="omr__buttons-text" key={ key }>
                      <div className="omr__category">{ key }</div>
                      <div className="omr__buttons-container">
                        {
                          _.map(value, (button, index) => {
                            return (
                              <Button
                                key ={ index }
                                className={
                                  classNames({
                                    'btn--primary omr__button': true,
                                    'btn--primary omr__button--new-line': index % 5 === 0 && index !== 0
                                  })
                                }
                                name={ key }
                                text={ button.label }
                                type="submit"
                                onClick={ handleClick(button.command, button.showResponse) }
                              />
                            );
                          })
                        }
                      </div>
                    </div>

                  );
                })
              }
            </div>
          }
          {
            !showResponse && <div className="omr__page">
              {
                _.map(otherTests, (value, key) => {
                  return (
                    <div className="omr__buttons-text" key={ key }>
                      <div className="omr__category">{ key }</div>
                      <div className="omr__buttons-container">
                        {
                          _.map(value, (button, index) => {
                            return (
                              <Button
                                key ={ index }
                                className="btn--primary omr__button"
                                name={ key }
                                text={ button.label }
                                type="submit"
                                onClick={ handleClick(button.command, button.showResponse) }
                              />
                            );
                          })
                        }
                      </div>
                    </div>
                  );
                })
              }
            </div>
          }
        </SimpleTabs>
        {
          showResponse && (
            <div className="omr__page">
              <ResponsePage
                title={ title }
                back={ goBack }
                breadCrumb={ tab === 0 ?  t('omr.mainTests')  :  t('omr.otherTests') }
              />
            </div>
          )
        }
      </div>
    </RetailPage>
  );
}

export default OMR;
